import React, { useEffect, useMemo, useState } from "react";
import { Card, Col, DatePicker, Divider, message, Row, Spin } from "antd";
import styled from "styled-components";
import { CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";
import { useSelector } from "react-redux";
import { getClientid, getUserInfo } from "redux/selectors";
import dayjs from "dayjs";
import { reduce } from "lodash";
import moment from "moment";

const StyledMineWrapper = styled.div`
  .total_weeks_logged {
    font-size: 16px;
    font-weight: 400;
  }
  .vertical_align {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }
  .label_value {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .card_title {
    font-size: 14px;
    font-weight: 600;
    padding: 0px !important;
  }
  .label_style {
    font-size: 14px;
    font-weight: 400;
    color: #636980;
  }
  .value_style {
    font-size: 16px;
    font-weight: 500;
  }
  .update_submitted {
    font-size: 12px;
    font-weight: 400;
    color: #636980;
  }

  .ant-card-head {
    border-bottom: 0px !important;
    padding: 0px 0px 0px 10px !important;
  }
  .ant-card-body {
    padding: 4px 14px 14px 14px !important;
  }

  .card_wrapper {
    position: relative;
    overflow: visible;
  }

  .draft_badge {
    position: absolute;
    top: 0px;
    right: 0px;
    display: inline-block;
    padding: 3px 25px;
    font-size: 10px;
    font-weight: 600;
    background: #eef2ff;
    color: #2d53da;
    border: 1px solid rgba(45, 83, 218, 0.12);
    border-radius: 0px 8px 0px 8px;
    box-shadow: 0 6px 12px rgba(17, 24, 39, 0.06);
    z-index: 5;
  }

  .card_wrapper:hover .draft_badge {
    background: #2d53da;
    color: #ffffff;
    border-color: #2d53da;
    cursor: pointer;
  }

  .card_wrapper .ant-card {
    border-radius: 8px;
  }

  .card_wrapper .ant-card:hover {
    border-color: #2d53da;
    cursor: pointer;
  }

  @media (max-width: 576px) {
    .card_title {
      font-size: 11px;
      font-weight: 500;
    }
    .label_style {
      font-size: 12px;
    }
    .value_style {
      font-size: 14px;
    }
    .update_submitted {
      font-size: 12px;
    }
    .draft_badge {
      font-size: 12px;
      padding: 4px 8px;
    }
    .total_weeks_logged {
      font-size: 14px;
    }
    .card_wrapper {
      margin-bottom: 16px;
    }
    .ant-card-head {
      padding-top: 24px !important;
    }
  }
`;

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  @media (max-width: 576px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px; /* space between label and picker */
    .total_weeks_logged {
      font-size: 14px;
      text-align: left;
      width: 100%;
    }
    .ant-picker {
      width: 100% !important; /* full width on mobile */
      border-radius: 12px;
    }
  }
`;

const getWeeksOfMonth = (monthYear) => {
  const date = dayjs(monthYear, "MMMM YYYY");
  const start = date.startOf("month");
  const end = date.endOf("month");

  let current = start.startOf("isoWeek");
  const weeks = new Set();

  while (current.isBefore(end) || current.isSame(end, "day")) {
    weeks.add(
      `${current.isoWeekYear()}-W${String(current.isoWeek()).padStart(2, "0")}`
    );
    current = current.add(1, "week");
  }

  return Array.from(weeks);
};

const weekFormat = (value) => {
  const startOfWeek = dayjs(value).startOf("isoWeek").format("Do MMM");
  const endOfWeek = dayjs(value).endOf("isoWeek").format("Do MMM YYYY");
  return `${startOfWeek} - ${endOfWeek}`;
};

const MineTab = ({
  setIsAddEdit,
  setLogDetails,
  setLogList,
  logList,
  setIsCurrentWeek,
  tabId,
}) => {
  const userInfo = useSelector(getUserInfo);
  const ClientId = useSelector(getClientid);
  const [loading, setLoading] = useState(false);

  const [selectedMonth, setSelectedMonth] = useState(dayjs());
  const [weeks, setWeeks] = useState([]);

  console.log("weeks-->", weeks);

  console.log("logList-->", logList);

  function getWeeksForMonth(year, monthZeroBased) {
    const ordinal = (n) => {
      const v = n % 100;
      if (v >= 11 && v <= 13) return `${n}th`;
      switch (n % 10) {
        case 1:
          return `${n}st`;
        case 2:
          return `${n}nd`;
        case 3:
          return `${n}rd`;
        default:
          return `${n}th`;
      }
    };

    const firstDay = new Date(year, monthZeroBased, 1);
    const lastDay = new Date(year, monthZeroBased + 1, 0);

    const firstDayWeekday = firstDay.getDay();
    const diffToMonday = firstDayWeekday === 0 ? -6 : 1 - firstDayWeekday;
    const firstMonday = new Date(firstDay);
    firstMonday.setDate(firstDay.getDate() + diffToMonday);

    const lastDayWeekday = lastDay.getDay();
    const diffToSunday = lastDayWeekday === 0 ? 0 : 7 - lastDayWeekday;
    const lastSunday = new Date(lastDay);
    lastSunday.setDate(lastDay.getDate() + diffToSunday);

    const weeks = [];
    let weekStart = new Date(firstMonday);

    while (weekStart <= lastSunday) {
      const weekEnd = new Date(weekStart);
      weekEnd.setDate(weekStart.getDate() + 6);

      if (weekEnd < firstDay || weekStart > lastDay) {
        weekStart.setDate(weekStart.getDate() + 7);
        continue;
      }

      const getISOWeek = (date) => {
        const tmp = new Date(
          Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
        );
        const dayNum = tmp.getUTCDay() || 7; // Monday=1, Sunday=7
        tmp.setUTCDate(tmp.getUTCDate() + 4 - dayNum);
        const yearStart = new Date(Date.UTC(tmp.getUTCFullYear(), 0, 1));
        const weekNo = Math.ceil(((tmp - yearStart) / 86400000 + 1) / 7);
        return `${tmp.getUTCFullYear()}-W${weekNo.toString().padStart(2, "0")}`;
      };

      const label = `${ordinal(weekStart.getDate())} - ${ordinal(
        weekEnd.getDate()
      )}`;
      const value = getISOWeek(weekStart); // value as ISO week

      weeks.push({ label, value });

      weekStart.setDate(weekStart.getDate() + 7);
    }

    return weeks;
  }

  const ProductLogGet = async () => {
    const now = dayjs();
    const year = now.year();
    const monthZeroBased = now.month();

    const Weeks = getWeeksForMonth(year, monthZeroBased);
    console.log("weeks12--->", Weeks);
    const weekLabels = Weeks?.map((week) => week.value);
    console.log("weekLabels--->", weekLabels);
    setLoading(true);
    const { statusCode, response } = await CALL_API(
      `productLogGet/${ClientId}`,
      "post",
      { week: weeks?.length > 0 ? weeks : weekLabels }
    );
    if (statusCode === STATUS_CODE.SUCCESS) {
      setLogList(
        response
          ?.filter((item) => item?.userid === userInfo?.userid)
          ?.sort(
            (a, b) => new Date(b.selected_date) - new Date(a.selected_date)
          )
      );
      setLoading(false);
    }
  };

  const monthWeeks = useMemo(() => {
    const monthToUse = selectedMonth
      ? selectedMonth.format("MMMM YYYY")
      : dayjs().format("MMMM YYYY");

    return getWeeksOfMonth(monthToUse);
  }, [selectedMonth, userInfo, ClientId]);

  const onChange = (date) => {
    setSelectedMonth(date); // store dayjs object
  };

  useEffect(() => {
    setWeeks(monthWeeks); // update only when monthWeeks changes
    // call API here only once per month change
  }, [monthWeeks]);

  useEffect(() => {
    if (tabId !== "1") return; // only fetch if Mine tab is active
    ProductLogGet();
  }, [weeks, tabId, selectedMonth, userInfo, ClientId]);

  const handleCardClick = (item) => {
    console.log("item121-->", item);

    const currentWeek = moment().format("GGGG-[W]WW");

    // check if item's week matches current week
    const isCurrentWeek = item.week === currentWeek;
    setIsCurrentWeek(isCurrentWeek);
    console.log("Is current week? -->", isCurrentWeek);

    setLogDetails(item);
    setIsAddEdit(true);
  };

  return (
    <StyledMineWrapper>
      <HeaderRow>
        <div className="total_weeks_logged">
          Total Weeks Logged: {logList?.length || 0}
        </div>
        {/* {selectedDate && ( */}
        <DatePicker
          onChange={onChange}
          picker="month"
          format="MMMM YYYY"
          value={selectedMonth}
          style={{ width: "200px", borderRadius: "16px" }}
        />
        {/* )} */}
      </HeaderRow>
      <br />
      <Spin spinning={loading}>
        <Row gutter={[16, 16]}>
          {logList?.map((item, index) => {
            const currentWeek = moment().format("GGGG-[W]WW");
            const isCurrentWeekCard = item.week === currentWeek;
            const isUpdatedCard = item.status === "draft";
            // Show "Updated On" if current week, else previous logic

            const dateLabel = isUpdatedCard ? "Updated On" : "Submitted On";
            const dateValue = isUpdatedCard
              ? dayjs(item.updatedon).format("Do MMM YYYY")
              : dayjs(item.submitedon).format("Do MMM YYYY") || "-";

            return (
              <Col
                xs={24}
                sm={12}
                md={12}
                lg={8}
                xl={8}
                key={index}
                onClick={() => handleCardClick(item)}
              >
                <div className="card_wrapper">
                  {item.status === "draft" && (
                    <div className="draft_badge">Draft</div>
                  )}

                  <Card
                    title={
                      <div className="card_title ">
                        Week : {weekFormat(item?.selected_date)}
                      </div>
                    }
                    variant="borderless"
                  >
                    <div className="vertical_align">
                      <div className="label_value">
                        <div className="label_style">Products</div>
                        <div className="value_style">{item?.productcount}</div>
                      </div>
                      <Divider type="vertical" style={{ height: 40 }} />
                      <div className="label_value">
                        <div className="label_style">Days Worked</div>
                        <div className="value_style">{item?.daysworked}</div>
                      </div>
                      <Divider type="vertical" style={{ height: 40 }} />
                      <div className="label_value">
                        <div className="label_style">Total Hours</div>
                        <div className="value_style">{item?.totalhours}</div>
                      </div>
                    </div>
                    <br />
                    <div className="update_submitted">
                      {dateLabel}: {dateValue}
                    </div>
                  </Card>
                </div>
              </Col>
            );
          })}
        </Row>
      </Spin>
    </StyledMineWrapper>
  );
};

export default MineTab;
